import React from "react";

import { ReactComponent as DownloadIcon } from "../../../assets/novosicones/Termos/DownloadIcon.svg";

const PoliticasPDF = ({
  enableCheckBox,
  enableButton,
  setEnableButton,
  url,
}) => {
  return (
    <>
      <div className="centralized-space-between divBtnAceites__entendiDownload">
        <span
          className={`${
            enableCheckBox
              ? "divBtnAceites__entendiDownload__enabled"
              : "divBtnAceites__entendiDownload__disabled"
          }`}
        >
          <input
            type="checkbox"
            disabled={enableCheckBox ? false : true}
            onChange={() => {
              setEnableButton(!enableButton);
            }}
          />
          Entendi e concordo
        </span>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="centralized"
          download
        >
          Fazer o download
          <DownloadIcon
            style={{ width: "14px", height: "14px", marginLeft: "5px" }}
          />
        </a>
      </div>
    </>
  );
};

export default PoliticasPDF;
